module.exports = __webpack_public_path__ + "img/generated-1772415849136.899da2b6.png";